import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@environment/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '@helpers/error-handler.service';
import { Observable, throwError } from 'rxjs';
import {
  LiveDisplayOverviewVM,
  LiveDisplayLocationVM,
  LiveDisplayTrendVM
} from '@models/backend-generated-models/models';

export interface KioskTokenResponse {
  token: string;
  expiresInMinutes: number;
  kioskId: string;
  siteId: number;
}

@Injectable({ providedIn: 'root' })
export class LiveDisplayService {
  constructor(
    private httpClient: HttpClient,
    private errorHandler: ErrorHandlerService
  ) {}

  getOverview$(siteId?: number): Observable<LiveDisplayOverviewVM[]> {
    let params = new HttpParams();
    if (siteId !== undefined && siteId !== null) {
      params = params.set('siteId', siteId.toString());
    }

    return this.httpClient
      .get<LiveDisplayOverviewVM[]>(`${environment.apiUrl}livedisplay/overview`, { params })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);
          return throwError(error);
        })
      );
  }

  getLocation$(locationId: string, siteId?: number): Observable<LiveDisplayLocationVM> {
    let params = new HttpParams();
    if (siteId !== undefined && siteId !== null) {
      params = params.set('siteId', siteId.toString());
    }

    return this.httpClient
      .get<LiveDisplayLocationVM>(`${environment.apiUrl}livedisplay/location/${encodeURIComponent(locationId)}`, { params })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);
          return throwError(error);
        })
      );
  }

  getTrend$(locationId: string, siteId?: number): Observable<LiveDisplayTrendVM> {
    let params = new HttpParams();
    if (siteId !== undefined && siteId !== null) {
      params = params.set('siteId', siteId.toString());
    }

    return this.httpClient
      .get<LiveDisplayTrendVM>(`${environment.apiUrl}livedisplay/location/${encodeURIComponent(locationId)}/trend`, { params })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);
          return throwError(error);
        })
      );
  }

  exchangeKioskToken$(deviceKey: string): Observable<KioskTokenResponse> {
    return this.httpClient
      .post<KioskTokenResponse>(`${environment.apiUrl}livedisplay/kiosk/token`, { deviceKey })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        })
      );
  }

  getKioskOverview$(token: string): Observable<LiveDisplayOverviewVM[]> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.httpClient
      .get<LiveDisplayOverviewVM[]>(`${environment.apiUrl}livedisplay/kiosk/overview`, { headers })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        })
      );
  }

  getKioskTrend$(locationId: string, token: string): Observable<LiveDisplayTrendVM> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.httpClient
      .get<LiveDisplayTrendVM>(`${environment.apiUrl}livedisplay/kiosk/trend/${encodeURIComponent(locationId)}`, { headers })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        })
      );
  }
}
